import React from 'react'
import { FaFilePdf } from "react-icons/fa";
import { useAccessCard } from '../../ContextProvider/Accesscardprovider';
import { useNavigate } from 'react-router-dom';

const Pdfcard = () => {

    const { pcode, accessPdfCard, accessCard } = useAccessCard();
    const navigate = useNavigate();

    // const handlePdfViewer = (pdf) => {
    //     accessCard();
    //     accessPdfCard();
    //     navigate('/pdf-viewer',{state:pdf});
    // }

    const handlePdfViewer = async (pdf) => {
        try {
            const controller = new AbortController();
            const timeout = setTimeout(() => controller.abort(), 300); // abort if too slow

            // Fake request to test if IDM intercepts it
            await fetch('https://example.com/fake.pdf', {
                method: 'GET',
                signal: controller.signal,
            });

            clearTimeout(timeout);

            // 🟢 No error: assume no IDM → continue
            accessCard();
            accessPdfCard();
            navigate('/pdf-viewer', { state: pdf });

        } catch (error) {
            // 🔴 Likely IDM or similar intercepted
            if (error.name !== 'AbortError') {
                alert("⚠️ Download manager (like IDM) might be interfering. Please disable it to view the PDF.");
            } else {
                // Still go ahead if it's just a timeout
                accessCard();
                accessPdfCard();
                navigate('/pdf-viewer', { state: pdf });
            }
        }
    };


    return (
        <div className='Enroll_course_container'>
            <h3>PDF</h3>
            <div className='Enroll_course_inner_container'>
                {pcode.map((pdf) => (
                    <div onClick={() => handlePdfViewer(pdf)}>
                        <div className='Enroll_course_card'>
                            <div>
                                <FaFilePdf size={40} className="course_icon" />
                            </div>
                            <div>
                                <span>{pdf.pdf_title}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Pdfcard